import { render } from "./TicketSection.vue?vue&type=template&id=0ec7a012"
import script from "./TicketSection.vue?vue&type=script&lang=js"
export * from "./TicketSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__